// Location Tab Component
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Button } from '../../../components/ui/button';
import { Plus, X, Navigation } from 'lucide-react';
import { directionIconOptions } from './constants';

export const LocationTab = ({ 
  formData, 
  setFormData,
  addDirection,
  updateDirection,
  removeDirection
}) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Città *</Label>
          <Input
            value={formData.city || ''}
            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
            placeholder="Milano"
            className="bg-white/5 border-white/10"
            data-testid="input-event-city"
          />
          <p className="text-xs text-muted-foreground">
            Verrà mostrata in evidenza nella homepage e nel titolo della pagina
          </p>
        </div>
        <div className="space-y-2">
          <Label>Regione/Paese</Label>
          <Input
            value={formData.location}
            onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            placeholder="Lombardia, Italia"
            required
            className="bg-white/5 border-white/10"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Nome Struttura</Label>
          <Input
            value={formData.venue_name}
            onChange={(e) => setFormData({ ...formData, venue_name: e.target.value })}
            placeholder="Superstudio Maxi"
            className="bg-white/5 border-white/10"
          />
        </div>
        <div className="space-y-2">
          <Label>Indirizzo Completo</Label>
          <Input
            value={formData.address}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            placeholder="Via Example 123, Milano"
            className="bg-white/5 border-white/10"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Google Maps Embed URL</Label>
        <Input
          value={formData.google_maps_embed}
          onChange={(e) => setFormData({ ...formData, google_maps_embed: e.target.value })}
          placeholder="https://www.google.com/maps/embed?pb=..."
          className="bg-white/5 border-white/10"
        />
        <p className="text-xs text-muted-foreground">
          Google Maps → Condividi → Incorpora mappa → Copia URL
        </p>
      </div>

      {/* Directions */}
      <div className="pt-4 border-t border-white/10">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Navigation size={18} className="text-primary" />
            <Label className="text-base font-semibold">Come Raggiungerci</Label>
          </div>
          <Button type="button" variant="outline" size="sm" onClick={addDirection}>
            <Plus size={14} className="mr-1" />
            Aggiungi
          </Button>
        </div>
        <div className="space-y-3">
          {formData.directions.map((direction, index) => (
            <div key={`dir-${direction.title || index}`} className="glass rounded-lg p-4 space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">Indicazione {index + 1}</span>
                <Button type="button" variant="ghost" size="sm" onClick={() => removeDirection(index)} className="h-6 w-6 p-0 text-destructive">
                  <X size={14} />
                </Button>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <Select
                  value={direction.icon}
                  onValueChange={(value) => updateDirection(index, 'icon', value)}
                >
                  <SelectTrigger className="bg-white/5 border-white/10">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent className="bg-card border-white/10">
                    {directionIconOptions.map((opt) => (
                      <SelectItem key={opt.value} value={opt.value}>
                        <div className="flex items-center gap-2">
                          <opt.icon size={14} />
                          {opt.label}
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Input
                  value={direction.title}
                  onChange={(e) => updateDirection(index, 'title', e.target.value)}
                  placeholder="In auto"
                  className="bg-white/5 border-white/10"
                />
              </div>
              <Textarea
                value={direction.description}
                onChange={(e) => updateDirection(index, 'description', e.target.value)}
                placeholder="Autostrada A1, uscita Milano Sud..."
                className="bg-white/5 border-white/10 min-h-16"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
